import { register, getPrefix } from '../../../Utils'
const fetch = require('node-fetch')

const VideoList = el => {
  const prefix = getPrefix(el)
  const videoPrefix = getPrefix(el.querySelector(`.${prefix}video-item`))
  const videos = el.querySelectorAll(`.${videoPrefix}video-item`)
  const modal = el.querySelector(`.${prefix}video-modal`)
  const backdrop = el.querySelector(`.${prefix}video-modal-backdrop`)
  const toggler = el.querySelectorAll(`.${prefix}video-modal-toggler`)
  const videoContainer = el.querySelector(`.${prefix}video-container`)
  const titleContainer = el.querySelector(`.${prefix}video-title`)
  const descriptionContainer = el.querySelector(`.${prefix}video-description`)
  const voteButtons = el.querySelectorAll(`.${videoPrefix}vote-button`)
  const errorBox = el.querySelector(`.${prefix}error-box`)
  const errorBoxContent = el.querySelector(`.${prefix}error-box-content`)

  const openVideo = (url, title, description) => {
    modal.classList.add(`${prefix}is--open`)
    backdrop.classList.add(`${prefix}is--open`)

    const videoElement = document.createElement('video')
    videoElement.controls = true

    const sourceElement = document.createElement('source')
    sourceElement.src = url

    videoElement.appendChild(sourceElement)
    videoContainer.appendChild(videoElement)

    videoElement.play()

    titleContainer.textContent = title
    descriptionContainer.textContent = description
  }

  const closeModal = () => {
    modal.classList.remove(`${prefix}is--open`)
    backdrop.classList.remove(`${prefix}is--open`)

    const childVideo = videoContainer.querySelector('video')
    if (childVideo) {
      childVideo.remove()
    }
  }

  const changeLikeCount = (element, action = 'add') => {
    const likeContainer = element.nextElementSibling.firstElementChild
    if (likeContainer) {
      let likeCount = +likeContainer.textContent
      if (action === 'add') {
        likeCount++
      } else {
        likeCount--
      }
      likeContainer.textContent = likeCount
    }
  }

  const voteClick = (e) => {
    e.preventDefault()
    const target = e.currentTarget
    const button = target.parentElement
    const action = button.dataset.action
    const voteLink = button.dataset.votelink
    const unvoteLink = button.dataset.unvotelink
    const voteIcon = button.querySelector(`.${videoPrefix}add-vote-button`)
    const unvoteIcon = button.querySelector(`.${videoPrefix}remove-vote-button`)
    const reqUrl = action === 'ajaxVote' ? voteLink : unvoteLink

    target.classList.add(`${videoPrefix}is--loading`)

    fetch(reqUrl)
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error('Something went wrong.')
      })
      .then(text => {
        target.classList.remove(`${videoPrefix}is--loading`)
        if (text.startsWith('OK:')) {
          if (action === 'ajaxVote') {
            button.dataset.action = 'ajaxUnVote'
            voteIcon.classList.remove(`${videoPrefix}is--active`)
            unvoteIcon.classList.add(`${videoPrefix}is--active`)
            changeLikeCount(button, 'add')
          } else {
            button.dataset.action = 'ajaxVote'
            unvoteIcon.classList.remove(`${videoPrefix}is--active`)
            voteIcon.classList.add(`${videoPrefix}is--active`)
            changeLikeCount(button, 'substract')
          }
        } else {
          errorBoxContent.textContent = text
          errorBox.classList.add(`${errorBox.dataset.prefix}is--open`)
          setTimeout(() => {
            errorBox.classList.remove(`${errorBox.dataset.prefix}is--open`)
          }, 5000)
        }
      })
      .catch(error => {
        target.classList.remove(`${videoPrefix}is--loading`)
        console.log('Request failed', error)
      })
  }

  videos.forEach(item => {
    const videoStarter = item.querySelector(`.${videoPrefix}video-starter`)
    const videoURL = videoStarter.dataset.videourl
    const videoTitle = videoStarter.dataset.videotitle
    const videoDescription = videoStarter.dataset.videodescription
    videoStarter.addEventListener('click', () => openVideo(videoURL, videoTitle, videoDescription))
  })

  toggler.forEach(el => {
    el.addEventListener('click', closeModal)
  })

  voteButtons.forEach(el => {
    el.addEventListener('click', voteClick)
  })
}

register('VideoList', VideoList)
